import { dateTimeFormat, timeFormat } from 'constants/formats';
import { format, isToday } from 'date-fns';

export const getDateTime = (date) => {
  if (!date) return '';

  const currentDate = new Date(date);
  const dateTime = isToday(currentDate)
    ? format(currentDate, timeFormat)
    : format(currentDate, dateTimeFormat);

  return dateTime;
};

export const getMailStatus = (recipient, t) => {
  const deliveredHtml = (
    <div className="d-flex align-items-center">
      <em className="text-success icon ni ni-shield-check-fill fs-20px mr-1" />
      <span>{t('DeliveredCommStatus')}</span>
    </div>
  );
  const sentHtml = (
    <div className="d-flex align-items-center">
      <em className="text-gray icon ni ni-shield-alert-fill fs-20px mr-1" />
      <span>{t('SentCommStatus')}</span>
    </div>
  );
  const bouncedHtml = (
    <div className="d-flex align-items-center">
      <em
        className="text-warning icon ni ni-shield-alert-fill fs-20px mr-1"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        title={recipient?.queued_reason}
        style={{ cursor: 'help' }}
      />
      <span>{t('BouncedCommStatus')}</span>
    </div>
  );
  const rejectedHtml = (
    <div className="d-flex align-items-center">
      <em
        className="text-danger icon ni ni-shield-alert-fill fs-20px mr-1"
        data-bs-toggle="tooltip"
        data-bs-placement="bottom"
        title={recipient?.reject_reason}
        style={{ cursor: 'help' }}
      />
      <span>{t('RejectedCommStatus')}</span>
    </div>
  );

  switch (recipient?.status) {
    case 'delivered':
      return deliveredHtml;
    case 'queued':
    case 'sent':
      return sentHtml;
    case 'bounced':
      return bouncedHtml;
    case 'rejected':
      return rejectedHtml;
    default:
      return '-';
  }
};

export const getMailDeliveredDate = (recipient) => {
  if (recipient?.status !== 'delivered') return '-';
  if (!recipient?.statusUpdatedAt) return '-';
  return new Date(recipient.statusUpdatedAt).toUTCString();
};
export const getDeliveredIp = (recipient) => recipient?.ip || '-';

export const updateRecipients = async (communication) =>
  communication?.recipients ?? [];
